import React from 'react';
// import { Helmet } from 'react-helmet-async';
import './../Pages/home.css'
// import TopCategories from '../components/CategorySection';
import WhyChooseUs from '../components/WhyChooseUs';
// import GallerySection from '../components/GallerySection';
import BlogSection from '../components/BlogSection';
import FaqSection from '../components/FaqSection';
import HeroBanner from '../components/HeroBanner';
import CategorySection from '../components/CategorySection';
import ProductSlider from '../components/ProductSlider';
import HomeHoursec from '../components/HomeHoursec';
import Testimonial from '../components/Testimonial';
import OfferSection from '../components/OfferSection';
import SeoHelmet from '../Seo/SeoHelmet';


const Home = () => {
  return (
    <>
<SeoHelmet page="home" />

    <HeroBanner/>
    <OfferSection/>
    <CategorySection/>
     <ProductSlider/>
     <HomeHoursec/>
      <WhyChooseUs/>
      {/* <GallerySection/> */}
      <Testimonial/>
      <BlogSection/>
      <FaqSection/>
    </>
  );
};

export default Home;
